/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A measurement of something such as a length or area. All measurements are to 2 decimal places and must be positive according to the XSD schema, but we allow for values from -2 inclusive, because of a potential issue with the RdSAP schema.
 */
export interface MeasurementUIDTOV0 { 
    /**
     * A numerical value representing the measurement.
     */
    value: number;
    /**
     * Units of measurements
     */
    quantity?: string;
}

